<style scoped>

* {
    border: 0px black solid;
}

.project_title {
  font-size: 40px;
  font-weight: bold;
  font-family: "Open Sans", sans-serif;
  padding-bottom: 40px;
  padding-top: 100px;
}

.description_text {
  font-size: 15px;
  font-family: "Roboto Mono", monospace;
  padding-bottom: 10px;
}

.tags {
  padding-top: 10px;
  font-size: 15px;
  font-style: italic;
  font-family: "Roboto Mono", monospace;

}

a:hover {
  color: hotpink;
  text-decoration: none;

}

a {
  color: gray;
}

.content {
  padding-bottom: 40px;
}

</style>

<template>
  <b-container fluid>
    <MenuBar/>
    <b-row>
      <b-col md="12">
        <p class="project_title">ATNOFS (A Traversal Network of Feminist Servers)</p>
      </b-col>
    </b-row>



    <b-row class="content">
      <b-col md="4">
        <div class="description_text">
        <p class="tags">Work sessions, radio broadcast, project management, system administration</p>
        <p>A Traversal Network of Feminist Servers (ATNOFS) is a collaborative project formed around intersectional feminist, ecological servers. Understanding servers as computers that host space and services for communities around them, this project exists inside, and in between, roaming servers and different networks. Our decentralized programme occured in 5 locations (The Netherlands, Belgium, Romania, Greece, Austria) with the collaboration of 6 partners (Varia, LURK, Constant, HYPHA, Feminist Hack Meetings, and ESC).</p>
        <p>In the first session, hosted in Varia, we focused on tools and methods to make space for understanding what feminist publishing infrastructures could be. We experimented with publishing infrastructures, and tools and methods emerged were later used for further knowledge sharing as the project moved location and the programme evolved. Together with the participants, the server developed for this session, Rosa, has also been traveling in between all different locations and collecting documentation and traces of practices from the different groups. </p>
        <p>The first session was precursed by a <a href="https://varia.zone/en/atnofs-varia.html">public radio broadcast</a>.</p>
        <p>The project is coordinated by me together with Cristina Cochior, and in close collaboration with <a href="https://constantvzw.org/site/">Constant</a>. The logs from the various sessions can be found <a href="http://varia.zone/logs/atnofs-varia/">here</a>.</p>

      </div>
      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/atnofs/rosa.jpg"></b-img>
        <p></p>
        <b-img class="img-fluid" src="media/atnofs/radio.jpg"></b-img>


      </b-col>

      <b-col md="4">
        <b-img class="img-fluid" src="media/atnofs/rosa_screen.jpg"></b-img>
      <p></p>
      <b-img class="img-fluid" src="media/atnofs/gentle.jpg"></b-img>

      </b-col>
    </b-row>

  </b-container>

</template>

<script>
import MenuBar from './MenuBar'
export default {
    name: 'ATNOFSPage',
    data: function() {
        return {
        }
    },
    components: {
        MenuBar
    }
}

</script>
